// listingspage/agent/AgentListingsPage.jsx

import React from 'react';
import { Grid, TextField, Button } from '@mui/material';

const AdvancedSearch = ({ search, setSearch }) => {
  return (
    <Grid container spacing={4} justifyContent="center">
      {/* Address Search */}
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          label="Address"
          name="address"
          variant="outlined"
          fullWidth
          value={search.address}
          onChange={(e) => setSearch({ ...search, address: e.target.value })}
        />
      </Grid>

      {/* City Search */}
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          label="City"
          name="city"
          variant="outlined"
          fullWidth
          value={search.city}
          onChange={(e) => setSearch({ ...search, city: e.target.value })}
        />
      </Grid>

      {/* Zip Code Search */}
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          label="Zip Code"
          name="zipCode"
          variant="outlined"
          fullWidth
          value={search.zipCode}
          onChange={(e) => setSearch({ ...search, zipCode: e.target.value })}
        />
      </Grid>

      {/* Min Price */}
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          label="Min Price"
          name="minPrice"
          type="number"
          variant="outlined"
          fullWidth
          value={search.minPrice}
          onChange={(e) => setSearch({ ...search, minPrice: e.target.value })}
        />
      </Grid>

      {/* Max Price */}
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          label="Max Price"
          name="maxPrice"
          type="number"
          variant="outlined"
          fullWidth
          value={search.maxPrice}
          onChange={(e) => setSearch({ ...search, maxPrice: e.target.value })}
        />
      </Grid>

      {/* Search Button */}
      <Grid item xs={12} sm={6} md={4} textAlign="center">
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
          onClick={() => setSearch({ ...search })} // Trigger re-filtering
        >
          Search
        </Button>
      </Grid>
    </Grid>
  );
};

export default AdvancedSearch;
